import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    windheight: '',
    HomeNum:'',
    userStr:localStorage.getItem('userStr') ?JSON.parse(localStorage.getItem('userStr')): '',
    fduId: localStorage.getItem('fduId') ? localStorage.getItem('fduId') : '',
    username: localStorage.getItem('username') ? localStorage.getItem('username') : '',
  },
  mutations: {
    changeuser(state, user) {
      state.fduId = user.userid.fduId;
      state.username = user.userid.name;
      state.userStr = user.userid
      localStorage.setItem('fduId', user.userid.fduId);
      localStorage.setItem('username', user.userid.name);
      localStorage.setItem('userStr', JSON.stringify(user.userid));
     

    },
    getWindowHeight(state, data) {
      state.windheight = data.windheight;
    },
    getHomeNum(state, data) {
      console.log(data);
      state.HomeNum = data.HomeNum;
    }
  },
  actions: {
  },
  modules: {
  }
})
